import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import PublicPageLayout from '@/Themes/Default/Layouts/PublicPageLayout';
import { isAuthenticated } from '@/Helpers/auth';
import PageLayout from '@/Themes/Default/Layouts/PageLayout';

/**
 * Site's privacy policy page
 */
const PrivacyPolicyPage = () => {
    useEffect(() => {
        document.title = 'Privacy Policy' + ' · ' + document.title;
    }, []);

    const pageContent = (
        <div className="footer-pages min-height">
            <h1>Privacy Policy</h1>
            <p></p>
            <p>Privacy Policy</p>
            <p>
                <em>For our&nbsp;Italian Privacy Policy, please click&nbsp;</em>
                <a href="https://www.dacbeachcroft.com/en/gb/privacy-policy-italy">
                    <em>here.</em>
                </a>
                <br />{' '}
                <strong>
                    <br /> INTRODUCTION
                </strong>
            </p>
            <p>
                DAC Beachcroft is committed to protecting the data of all people we deal with.&nbsp; Our Privacy Policy is divided into separate sections for your ease. Each section sets out important information about how DAC Beachcroft may collect and use your data depending upon the categories of individuals whose
                data we process (such reference to “data” means all forms of personal data).
            </p>
            <p>This Policy applies to our clients, prospective clients, individuals with whom we direct market to and others who are browsing our website. It applies globally and is based on UK and European data protection principles.&nbsp;We will update this Policy from time to time."</p>
            <p>
                <strong>WHO WE ARE</strong>
            </p>
            <p>DAC Beachcroft is an international legal business which operates through separately constituted and regulated legal entities providing legal and/or claims handling services in accordance with the relevant laws of the jurisdictions in which the different entities operate.&nbsp;</p>
            <p>
                The use of words and/or phrases such as "DAC Beachcroft", "we", "us" or "our" is for convenience only and refers to any of the entities listed on our&nbsp;
                <a href="https://www.dacbeachcroft.com/en/gb/about/legal-and-regulatory">
                    <strong>Legal and Regulatory</strong>
                </a>
                &nbsp;page, each of which is a separate data controller in their own right.
            </p>
            <p>
                <strong>WHAT DATA DO WE COLLECT AND WHERE DO WE GET IT FROM?</strong>
            </p>
            <p>DAC Beachcroft will collect, use and store your data for a wide variety of reasons in connection with your relationship with us and we collect your data from a range of sources.</p>
            <p>The table below sets out the main categories of data that we collect and the sources we collect it from. The table is not exhaustive and there may be other data and other sources which DAC Beachcroft collects, uses and stores in the context of our relationship.</p>
            <table border="0">
                <tbody>
                    <tr>
                        <td>
                            <p>
                                <strong>Type of data</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Source of data</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Contact information</strong>&nbsp;including your name, address, telephone number(s), e-mail, your organisation details (including job title, employer, place of work and organisation contact details) and your gender
                            </p>
                        </td>
                        <td>
                            <p>You, our client and/or our client’s insured, intermediaries, those involved in a matter and/or publically available resources</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Regulatory information</strong>&nbsp;including your date of birth, identity information, details of whether you are a Politically Exposed Person
                            </p>
                        </td>
                        <td>
                            <p>You, our client and/or our client’s insured, intermediaries, those involved in a matter and/or publically available resources</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Matter information</strong>&nbsp;including policy number/policy inception date, claim number, loss details/claim and any information provided to us in relation to the purpose upon which we are acting
                            </p>
                            <p>&nbsp;</p>
                        </td>
                        <td>
                            <p>You, our client and/or our client’s insured, intermediaries, those involved in a matter and/or publically available resources</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Billing information&nbsp;</strong>including bank account details and payment/billing instructions
                            </p>
                        </td>
                        <td>
                            <p>You, our client and/or our client’s insured, intermediaries, those involved in a matter and/or publically available resources</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Marketing preferences</strong>&nbsp;including marketing communication preferences, legal and industry sector interests
                            </p>
                        </td>
                        <td>
                            <p>You or your employer (if they are our actual or prospective client)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Device Usage and Browsing information&nbsp;</strong>including IP addresses, online identifiers and information automatically generated through your use of our website and digital platforms/media
                            </p>
                        </td>
                        <td>
                            <p>You and our website / digital platforms</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Visitors to our offices&nbsp;</strong>including any of the above types of data, CCTV recordings, building access records, health related information including dietary and access requirements
                            </p>
                        </td>
                        <td>
                            <p>You or your employer (if they are our actual or prospective client)</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                <strong>HOW DO WE USE DATA?</strong>
            </p>
            <p>DAC Beachcroft uses your data for a variety of purposes in order to provide our services as an international legal and/or claims handling services provider.</p>
            <p>
                We have set out in the table below the main purposes for which your data may be processed and the ‘lawful basis’ for the processing i.e. the legal reason we are able to process your data. For information regarding how we use cookies and similar technologies in connection with your use of our website and
                digital platforms or forms of communication, please read our&nbsp;
                <a href="/en/gb/about/cookies/">
                    <strong>Cookies Policy</strong>
                </a>
                .
            </p>
            <p>
                <strong>Personal data</strong>
            </p>
            <table border="0">
                <thead>
                    <tr>
                        <td>
                            <p>
                                <strong>What we use data for</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Our reasons / lawful basis</strong>
                            </p>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <p>Providing legal advice and/or claims handling services (which may include the provision of management information to our client or as requested as a service in its own right to our client directly)</p>
                            <p>&nbsp;</p>
                        </td>
                        <td>
                            <p>To perform our contract with you</p>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                Corresponding with you or to others (electronically and/or physically (e.g. by letter, fax, telephone (including within any recording or transcription), email, secure sharing portal or SMS), which may include the use of third party suppliers (such as electronic signature providers) to
                                assist in delivering the services to you)
                            </p>
                        </td>
                        <td>
                            <p>To perform our contract with you</p>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Providing you with access to your information via our client portal offering and collecting information about your usage of our portals, which may involve the use of third party suppliers</p>
                        </td>
                        <td>
                            <p>To perform our contract with you</p>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Part of court or legal proceedings (including legal claims, criminal actions, inquests, tribunals, arbitrations, mediations and/or regulatory actions)</p>
                        </td>
                        <td>
                            <p>To perform our contract with you</p>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                Managing and running checks within our anti-fraud systems and sharing information with our clients and other appropriate organisations for the purpose of preventing, detecting or prosecuting fraud (which may involve reference to Credit Reference Agencies (please see&nbsp;
                                <a href="https://clicktime.symantec.com/3NUvvxoC8zCuAx5CYRJzv4F6H2?u=https%3A%2F%2Fwww.transunion.co.uk%2Fcrain">https://www.transunion.co.uk/crain</a>&nbsp;and&nbsp;
                            </p>
                            <p>
                                <a href="https://www.transunion.co.uk/legal-information/bureau-privacy-notice">https://www.transunion.co.uk/legal-information/bureau-privacy-notice</a>)
                            </p>
                            <p>&nbsp;</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Conducting client due diligence checks, which may include the use of third party suppliers (such as identity verification providers) and screening for financial, adverse media, political positions and other sanctions</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Managing and running checks within our internal databases which relate to legal proceedings and/or claims handling services</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Complying with our legal obligations or making disclosures to government, regulatory or other public bodies where the disclosure is appropriate and/or permitted by law</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Managing our professional relationships with our clients and third parties</p>
                        </td>
                        <td>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Ensuring business policies are adhered to, e.g. policies covering security and internet use</p>
                        </td>
                        <td>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Operational reasons, such as improving efficiency, training and quality control including obtaining your feedback on the provision of our services</p>
                        </td>
                        <td>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Providing training and legal updates</p>
                        </td>
                        <td>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Sharing information within the DAC Beachcroft group (for example where one of our entities is advising or providing services to another entity, or where we are checking for legal or commercial conflicts)</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Preventing unauthorised access and modifications to systems</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Protecting the security of systems, website pages and data used to provide the services</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>
                                We may also use your personal data to ensure the security of systems and data to a standard that goes beyond our legal obligations, and in those cases our reasons are for legitimate interests, i.e. to protect systems, website pages (such as via the use of Google ReCAPTCHA) and data and
                                to prevent and detect criminal activity that could be damaging for you and/or us
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Marketing (by post, email and/or via our user account area for which you are always able to opt-out/unsubscribe with no detriment), development and/or tendering in relation to our products and services</p>
                        </td>
                        <td>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                Providing access to our files for audit, review or other quality assurance checks by our clients, regulators, auditors, professional advisors, crime and law enforcement agencies, governmental bodies (for example the Garda National Bureau of Criminal Investigation/An Garda Siochana in
                                Ireland) and/or certification bodies (for example The Solicitors Regulation Authority in the UK)
                            </p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Providing information to our brokers and insurers</p>
                        </td>
                        <td>
                            <p>To comply with legal and regulatory obligations</p>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                Day to day operations of our business. For this we may use third party service providers (for example access in our premises via 3<sup>rd</sup> party systems, procurement services, recruitment consultants, general office services, library services, translation services, website service
                                providers and/or IT service providers)
                            </p>
                        </td>
                        <td>
                            <p>For a legitimate interest</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                <strong>Special categories of data</strong>
            </p>
            <p>Certain categories of data are considered "special categories of data" and are subject to additional safeguards. The special categories of personal data which we process may relate to:</p>
            <ul>
                <li>Racial or ethnic origin;</li>
                <li>Political opinions;</li>
                <li>Religious or philosophical beliefs;</li>
                <li>Trade union membership;</li>
                <li>Genetic and/or biometric data;</li>
                <li>Physical and mental health; and/or</li>
                <li>Sex life and/or sexual orientation.</li>
            </ul>
            <p>For the special categories of personal data set out above, additional lawful bases apply as set out in the table below. Again the information in the table is not exhaustive and DAC Beachcroft may undertake additional processing of data based on the lawful bases set out below.</p>
            <table border="0">
                <thead>
                    <tr>
                        <td>
                            <p>
                                <strong>What we use your special category personal data for</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Our reasons / lawful basis</strong>
                            </p>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <p>Providing legal and/or claims handling services to our client</p>
                        </td>
                        <td>
                            <p>As necessary for the establishment, exercise or defence of legal claims</p>
                            <p>As necessary for reasons of substantial public interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Obtaining legal advice, establishing, defending and enforcing our legal rights and obligations in connection with, any court or legal proceedings</p>
                        </td>
                        <td>
                            <p>As necessary for the establishment, exercise or defence of legal claims</p>
                            <p>As necessary for reasons of substantial public interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Complying with all relevant legal and regulatory requirements (such as anti-money laundering and client verification checks)</p>
                        </td>
                        <td>
                            <p>As necessary for reasons of substantial public interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Responding to binding requests or search warrants or orders from courts, governmental, regulatory and/or enforcement bodies and authorities or sharing information (on a voluntary basis) with the same</p>
                        </td>
                        <td>
                            <p>As necessary for the establishment, exercise or defence of legal claims</p>
                            <p>As necessary for reasons of substantial public interest</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Hosting you at our offices</p>
                        </td>
                        <td>
                            <p>You have given your explicit consent to the processing for your dietary and access requirements</p>
                            <p>It is necessary to protect somebody’s vital interests or they are incapable of giving consent in case of any accidents and emergencies at our offices</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                In addition to the above, there may be occasions where we process personal data relating to criminal convictions and offences. We process criminal offence data where necessary in relation to legal claims, to prevent or detect unlawful acts, to comply with regulatory requirements relating to unlawful
                acts and dishonesty and to prevent fraud / money laundering.
            </p>
            <p>
                <strong>Marketing</strong>
            </p>
            <p>Where you receive a marketing email, event invitation or other direct mailing from us, we may collect information about you in the following ways:</p>
            <ul>
                <li>Opening emails: if you open the email either by downloading images in the email or clicking in a link, we log such activity on our database so we can personalise future emails to you.</li>
                <li>View as web page: If you click on the "view it as a web page" link, a tracking code is generated so that the web page is personalised in the same way as the email.</li>
                <li>Links to web pages: If you click on any web link, a tracking code is generated which we use to log such activity on our database.</li>
                <li>Unsubscribe: If you unsubscribe from any direct marketing, invitation or alert, we will continue to store your data on a "marketing suppression list" so as to record your preference.</li>
                <li>
                    Event RSVP buttons: In our event invitations and confirmations we provide buttons to allow you to accept, decline, cancel (and register if you are not the original recipient of the invitation) for that event. Clicking on these buttons will generate a tracking code so we can record your choice in our
                    database to help us manage the event.
                </li>
            </ul>
            <p>
                <strong>Improving our services&nbsp;</strong>
            </p>
            <p>
                In order for us to improve our services, we endeavour to use dummy or anonymised data wherever possible. Where that is not possible, we may use personal data to test the improvement of a system(s) or development of a new system(s) in pursuit of our legitimate business interests (but only if these are
                not overridden by a person’s interests, rights or freedoms). That being said, we will only do so in a safe and controlled manner in accordance with our obligations under data protection legislation.
            </p>
            <p>
                In the event that you object to the use of your personal data as part of our testing only, you are able to object (by emailing:&nbsp;<a href="mailto:dataprotectionenquiryteam@dacbeachcroft.com">dataprotectionenquiryteam@dacbeachcroft.com</a>) whereby we will add your name to an opt-out list and your
                personal data will not be used as part of any test.
            </p>
            <p>
                <strong>WHEN DO WE SHARE DATA?</strong>
            </p>
            <p>DAC Beachcroft may, as follows, share your data with the following main parties in certain circumstances and where it is necessary to achieve the purposes detailed above:</p>
            <ul>
                <li>Our client and our client’s insured;</li>
                <li>Intermediaries (for example, loss adjusters, investigators, claims management suppliers and/or coverholders etc);</li>
                <li>Claimants/Plaintiffs;</li>
                <li>Defendants/Respondents;</li>
                <li>
                    3<sup>rd</sup>&nbsp;parties;
                </li>
                <li>Experts;</li>
                <li>Witnesses;</li>
                <li>Counsel;</li>
                <li>
                    3<sup>rd</sup>&nbsp;party solicitors;
                </li>
                <li>Individuals who are involved in court or other legal proceedings (including legal claims, criminal actions, inquests, tribunals, arbitrations, mediations and/or regulatory actions) or the provision of related legal advice and/or claims handling;</li>
                <li>People who are involved in contracts and transactions we are working on (for example other businesses/individuals our clients are contracting or working with);</li>
                <li>Our business contacts;</li>
                <li>People who attend our seminars or receive our legal updates, and/or who visit our website;</li>
                <li>Service providers (for example (but not limited to): People Pool consultants, Lawyer Connective consultants, recruitment consultants, general office services, library services, translation services, website service providers and/or IT service providers); and/or</li>
                <li>
                    Our regulators, insurers, auditors, professional advisers, crime and law enforcement agencies, governmental bodies (for example the Garda National Bureau of Criminal Investigation/An Garda Siochana in Ireland) and/or certification bodies (for example The Solicitors Regulation Authority in the UK and
                    in relation to our ISO27001, ISO9001 and Cyber Essentials Plus certifications).
                </li>
            </ul>
            <p>The list above is not exhaustive.</p>
            <p>
                <strong>Transferring data out of the United Kingdom (UK) and European Economic Area (EEA)</strong>
            </p>
            <p>
                As we are a global legal services group, data may be transferred outside of the UK and the EEA. For example this may be in relation to an international legal claim or transaction, or where we are sharing information with our colleagues or third party service providers who operate outside of the UK or
                the EEA.
            </p>
            <p>
                Where we transfer your personal data outside the UK or the EEA we do so on the basis of an adequacy decision or (where this is not available) legally-approved standard data protection clauses. In the event we cannot or choose not to continue to rely on either of those mechanisms at any time, we will not
                transfer your data outside the UK or the EEA unless we can do so on the basis of an alternative mechanism or exception provided by applicable data protection law.<strong>&nbsp;</strong>
            </p>
            <p>
                <strong>HOW DO WE KEEP DATA SECURE?</strong>
            </p>
            <p>
                We have appropriate technical and organisational measures in place to protect data. We limit access to data to those who have a genuine business need to access it. Those processing data will do so only in an authorised manner and are subject to a duty of confidentiality. We continually test our systems
                and are ISO 27001 and Cyber Essentials PLUS certified, which means we follow industry standards for information security.
            </p>
            <p>We also have procedures to deal with any suspected data breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p>
            <p>
                <strong>HOW LONG WILL WE KEEP DATA?</strong>
            </p>
            <p>
                DAC Beachcroft's policy is to retain data only for as long as needed to fulfil the purpose(s) for which it was collected, or otherwise as required under applicable jurisdictional laws and/or regulations and/or business continuity purposes. Under some circumstances we may anonymise your data so that it
                can no longer be associated with you. We reserve the right to retain and use such anonymous data for any legitimate business purpose without further notice to you.
            </p>
            <p>DAC Beachcroft will typically retain data for periods set out below subject to any exceptional circumstances and/or to comply with particular jurisdictional laws or regulations and/or business continuity purposes:</p>
            <table border="0">
                <tbody>
                    <tr>
                        <td colSpan="2">
                            <p>Subject to the exceptions below, and unless there is any other valid legal, regulatory, client or business reason to retain it beyond that timescale, all matter files will usually be destroyed at approximately 7 years after the matter has been closed.</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Claims Files</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Retention Period</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Claimant/Plaintiff/pursuer is a child</p>
                        </td>
                        <td>
                            <p>Once the child reaches 28 years of ages</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>ii)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Claimant/Plaintiff/pursuer is under a disability</p>
                        </td>
                        <td>
                            <p>50 years from data of final order (reviewed every 10 years)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>iii)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Claimant/Plaintiff/pursuer has a provisional damages and/or periodic payments award</p>
                        </td>
                        <td>
                            <p>Whichever of timescales at i) and ii) is applicable given terms of final order</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Real Estate/Construction Files</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Retention Period</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Property purchase</p>
                        </td>
                        <td>
                            <p>15 years from file closure</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Files relating to deeds</p>
                        </td>
                        <td>
                            <p>15 years from file closure</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Files relating to leases</p>
                        </td>
                        <td>
                            <p>2 years longer than term of lease (maximum of 27 years)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Files relating to construction</p>
                        </td>
                        <td>
                            <p>15 years from file closure</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Where client is a mortgagee</p>
                        </td>
                        <td>
                            <p>2 years longer than term of loan</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Client Due Diligence</strong>
                            </p>
                        </td>
                        <td>
                            <p>&nbsp;</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Client Due Diligence Material</p>
                        </td>
                        <td>
                            <p>5 years after the business relationship ends or the occasional transaction is completed.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                <strong>WHAT ARE YOUR RIGHTS IN RELATION TO YOUR DATA?</strong>
            </p>
            <p>DAC Beachcroft will always seek to process your data in accordance with our obligations, our rights and your rights.</p>
            <p>You will not be subject to decisions based solely on automated data processing without your prior consent.</p>
            <p>
                In certain circumstances, you have the right to seek the erasure or correction of your data, to object to particular aspects of how your data is processed, and otherwise to seek the restriction of the processing of your data. You also have the right to request the transfer of your data to another party
                in a commonly used format.
            </p>
            <p>
                You have a separate right of access to your data processed by DAC Beachcroft. You may be asked for information to confirm your identity and/or assist DAC Beachcroft to locate the data you are seeking as part of DAC Beachcroft's response to your request. If you wish to exercise your right of access,
                please contact our Data Protection Enquiry Team (outlined below).
            </p>
            <p>You have the right to raise any concerns or complain about how your data is being processed with:&nbsp;</p>
            <table border="0">
                <tbody>
                    <tr>
                        <td>
                            <p>
                                <strong>Location</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Data Protection Supervisory Authority</strong>
                            </p>
                        </td>
                        <td>
                            <p>
                                <strong>Contact details</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>UK</strong>
                            </p>
                        </td>
                        <td>
                            <p>Information Commissioner's Office (ICO)</p>
                        </td>
                        <td>
                            <p>
                                ICO's website:&nbsp;<a href="https://ico.org.uk/concerns/">https://ico.org.uk/concerns/</a>&nbsp;or +44 (0) 303 123 1113 or&nbsp;<a href="mailto:casework@ico.org">casework@ico.org</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>France</strong>
                            </p>
                        </td>
                        <td>
                            <p>Commission nationale de l'informatique et des libertés (CNIL)</p>
                        </td>
                        <td>
                            <p>
                                CNIL’s website:&nbsp;<a href="https://www.cnil.fr/">https://www.cnil.fr/</a>&nbsp;or +33 (0) 1 53 73 22 22
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Ireland</strong>
                            </p>
                        </td>
                        <td>
                            <p>Data Protection Commissioner (DPC)</p>
                        </td>
                        <td>
                            <p>
                                DPC's website:&nbsp;<a href="https://dataprotection.ie/docs/complaints/1592.htm">https://dataprotection.ie/docs/complaints/1592.htm</a>&nbsp;or +353 1800437 737 or&nbsp;<a href="mailto:info@dataprotection.ie">info@dataprotection.ie</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Italy</strong>
                            </p>
                        </td>
                        <td>
                            <p>Garante per la Protezione dei Dati Personali (GPDP)</p>
                        </td>
                        <td>
                            <p>
                                GPDP’s website:&nbsp;<a href="https://www.garanteprivacy.it/web/garante-privacy-en">https://www.garanteprivacy.it/web/garante-privacy-en</a>&nbsp;or +39 06 696771
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <strong>Spain</strong>
                            </p>
                        </td>
                        <td>
                            <p>Spanish Data Protection Agency/Agencia Española de Protección de Datos (AEPD)</p>
                        </td>
                        <td>
                            <p>
                                AEPD's website:&nbsp;<a href="https://www.agpd.es/portalwebAGPD/index-iden-idphp.php">https://www.agpd.es/portalwebAGPD/index-iden-idphp.php</a>&nbsp;or +34 901 100 099 / +34 91 266 35 17
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>We have elected the DPC as our Lead Supervisory Authority within the EU.</p>
            <p>
                <strong>WHERE CAN YOU GET FURTHER INFORMATION?</strong>
            </p>
            <p>If you have any questions about this Policy, want to exercise any of your rights in relation to your data as set out above or want to raise any concerns or complain about how your data is being processed, please use our contact details below in the first instance:</p>
            <p>
                <strong>Email</strong>:&nbsp;<a href="mailto:dataprotectionenquiryteam@dacbeachcroft.com">dataprotectionenquiryteam@dacbeachcroft.com</a>
            </p>
            <p>
                <strong>Post:&nbsp;</strong>Data Protection Enquiry Team
                <br /> DAC Beachcroft
                <br /> St Paul's House
                <br /> 23 Park Square South
                <br /> Leeds
                <br /> United Kingdom
                <br /> LS1 2ND
            </p>
            <p>
                <strong>DO YOU NEED EXTRA HELP?</strong>
            </p>
            <p>If you would like this Policy in another format (for example audio or large print), please contact us (see ‘Where can you get further information’ above).</p>
            <p>
                <strong>Last updated: June 2023</strong>
            </p>
        </div>
    );

    return isAuthenticated() ? (
        <PageLayout>{pageContent}</PageLayout>
    ) : (
        <PublicPageLayout>
            <Card>{pageContent}</Card>
        </PublicPageLayout>
    );
};

export default PrivacyPolicyPage;
